export default {

    ARBITER_API_BASE_PATH : "/portal/arbiter/api/v1",
    ARBITER_API_TRANSACTIONS: "/transactions",
    ARBITER_API_TRANSACTION_GROUPS : "/transaction-groups",
    ARBITER_API_DISPUTES : "/disputes",
    ARBITER_API_REASON_CODES : "/reason-codes",
    ARBITER_API_REASON_CODES_BY_CATEGORY : "/reason-codes/dispute-category",
    ARBITER_API_DISPUTE_REGIONS : "/dispute-regions",
}


// WEBPACK FOOTER //
// ./src/configurations/urls.js